// extracted by mini-css-extract-plugin
export var ctaContainer = "bh_dy";
export var faqContainer = "bh_dC";
export var infoBoxContainer = "bh_dz";
export var ratesArticlesContainer = "bh_dx";
export var trustPilot = "bh_dB";